import React from 'react';
import { Typography, TypographyProps } from '@mui/material';

export interface TooltipHeaderProps extends TypographyProps {}

/**
 * Headline for @mui tooltip, that should be passed as first element in title:
 *  <Tooltip title={<>
 *    <TooltipHeader>Headline</TooltipHeader>
 *    {children}
 *  </>} />
 */
export const TooltipHeader = ({ children, sx, className, ...rest }: TooltipHeaderProps) => {
  return (
    <Typography
      sx={{
        display: 'block',
        maxWidth: 'none',
        // move to the sides of tooltip
        mt: '-24px',
        mb: '12px',
        mx: '-24px',
        // spacing
        py: '16px',
        px: '24px',
        // style
        backgroundColor: 'onSurface.os800',
        color: 'onSurface.os0',
        borderTopLeftRadius: 'inherit',
        borderTopRightRadius: 'inherit',
        // other variants are controlled from tooltip.theme.ts
        ...sx,
      }}
      variant="caption2"
      component="h4"
      className={['FlowTooltip-header', className].filter(Boolean).join(' ')}
      {...rest}
    >
      {children}
    </Typography>
  );
};
